function WelcomePage() {

    return <>
        <div className="container py-5 px-3 my-4 rounded" style={{ background: "#E9ECEF" }}>
            <h1 className="text-center">Welcome to Tempus</h1>
            <p>Tempus is the ideal solution for those who want to keep track of their working hours but don't have the patience to fill in spreadsheets or something similar.
                Any professional who is not in the habit of controlling their working hours can easily fail to notice that their
                quality of life is being lost. Being aware of how your time is used can give you a real dimension of the value that each minute has.
            </p>
            <p> In this sense, Tempus presents itself as a simple, fast and safe tool for you to record your working hours, allowing you to extract from these data
                the information you need to optimize your time.
            </p>
        </div>
    </>;
}

export default WelcomePage;